__turbopack_context__.v({
  "heroContainer": "ImageTrailHero-module__ZOFVvW__heroContainer",
  "mobileFallback": "ImageTrailHero-module__ZOFVvW__mobileFallback",
  "textContent": "ImageTrailHero-module__ZOFVvW__textContent",
  "title": "ImageTrailHero-module__ZOFVvW__title",
  "trailImage": "ImageTrailHero-module__ZOFVvW__trailImage",
});
